import * as React from "react";
import AccountsPage from "../accounts/components/pages/AccountsPage";

const BookmakersScreen: React.FC = () => <AccountsPage accountType="bookmaker" />;

export default BookmakersScreen;
